import React, { useState } from "react";
// import yesIcon from "../../images/YES.svg";
// import noIcon from "../../images/NO.svg";
import { Grid, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { isEmpty, range } from "lodash";
// import Draggable from "react-draggable";
// import "animate.css/animate.css";


const DropableLabel = (props) => {
  const {
    aref,
    title,
    inAnswer,
    getAnswers,
    currentAnswer,
    ifAnswer,
    classes,
    onDragEnd,
    onDragUpdate,
    dragStarted,
    setDragStarted,
    showAnimation,

    label,
    left,
    right,
    marginTop,
    rotate,
    isRight,
    isSubmitted,
    isCorrectLabel
  } = props;

let borderColor = isSubmitted ? isCorrectLabel ? "green" : "red" : "#003e4c"
let borderStyle = isSubmitted ? "solid" : "dashed"
  return (
    <div ref={aref} style={{ position: "absolute", backgroundColor: inAnswer ? "#1db2d7" : "#fff" , border: `2px ${borderColor} ${borderStyle}`, borderRadius: 10, marginTop: marginTop, [!isRight && "left"]: left, [isRight && "right"]: right,  transform: rotate }}>
    <h4 className={classes.text}>{label ? label: "PLACE LABEL"}</h4>
  </div>
  );
};

export default withStyles(styles)(DropableLabel);
